const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  enableMock: true,
};

export default appConfig;
